import type { VueQueryPluginOptions } from '@tanstack/vue-query'
import { QueryClient, VueQueryPlugin } from '@tanstack/vue-query'

declare module '@tanstack/vue-query' {
  interface Register {
    defaultError: ErrorResponse
  }
}

export default defineNuxtPlugin((nuxt) => {
  const { getToken, getRefreshToken } = useAuth()

  const isTokenExpired = (error: ErrorResponse) => {
    return (
      'response' in error &&
      error.response.status === HttpStatusCode.Unauthorized &&
      !!getToken() &&
      !!getRefreshToken()
    )
  }

  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5000,
        retry: (failureCount, error) => {
          const isFetchError =
            'name' in error && error.name === 'FetchError' && !error.response
          const shouldRetry =
            'response' in error &&
            RETRY_STATUS_CODES.includes(error.response?.status)
          return (
            failureCount < RETRY_COUNT &&
            (isFetchError || shouldRetry || isTokenExpired(error))
          )
        },
      },
      mutations: {
        retry: (failureCount, error) =>
          isTokenExpired(error) && failureCount < RETRY_COUNT,
      },
    },
  })
  const options: VueQueryPluginOptions = { queryClient }

  nuxt.vueApp.use(VueQueryPlugin, options)
})
